import type { SectionStatus } from '@/state/billing/useBillingSettings';
import { DisclosureButton } from '../../ConsolePanel';

type SectionStatusLineProps = {
  status: SectionStatus;
  loadingText: string;
  errorText: string;
};

/**
 * The one line a billing section shows before it has data: loading, or failed
 * with a way to try again. Loading and failure are different sentences, so a
 * request that failed never reads as one still on its way.
 */
export const SectionStatusLine = ({ status, loadingText, errorText }: SectionStatusLineProps) =>
  status.isError ? (
    <div role="alert" className="flex flex-wrap items-center gap-3">
      <p className="text-danger m-0 text-meta leading-[1.6]">{errorText}</p>
      <DisclosureButton onClick={status.retry}>Try again</DisclosureButton>
    </div>
  ) : (
    <p className="supporting m-0">{loadingText}</p>
  );
